import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const BellIcon = memo<ISvgProps>((props, { className }) => (
  <Svg className={className} width="30.216" height="30.266" viewBox="0 0 30.216 30.266" {...props}>
    <g id="fi-rr-bell-ring" transform="translate(-0.004 0)">
      <path
        id="Path_22026"
        data-name="Path 22026"
        d="M26.3,19.333,21.546,27.1a6.6,6.6,0,0,1-4.88,3.124,6.7,6.7,0,0,1-.792.047,6.573,6.573,0,0,1-3.783-1.2,5.979,5.979,0,0,1-8.435-8.28L2,19.125A6.638,6.638,0,0,1,3.2,8.785l7.272-4.5A11.172,11.172,0,0,1,23.5,4.983L25.589,2.89a1.261,1.261,0,1,1,1.783,1.783l-2.09,2.091A11.288,11.288,0,0,1,26.3,19.333ZM10.169,27.3l-4.69-4.691a3.431,3.431,0,0,0,.584,4.116A3.565,3.565,0,0,0,10.169,27.3ZM22.68,7.626A8.685,8.685,0,0,0,11.814,6.431l-7.285,4.5a4.117,4.117,0,0,0-.747,6.414l9.193,9.194A4.117,4.117,0,0,0,19.4,25.78l4.735-7.724A8.748,8.748,0,0,0,22.68,7.619Zm1.613,22.64a1.261,1.261,0,0,1-.745-2.28,10.887,10.887,0,0,0,4.18-6.819,1.261,1.261,0,1,1,2.463.542,13.493,13.493,0,0,1-5.155,8.314A1.261,1.261,0,0,1,24.293,30.265ZM1.26,7.237A1.261,1.261,0,0,1,.251,5.227,13.483,13.483,0,0,1,8.716.025a1.261,1.261,0,0,1,.5,2.472,10.89,10.89,0,0,0-6.952,4.23,1.261,1.261,0,0,1-1.009.511Z"
        transform="translate(0 0)"
        fill="#3477eb"
      />
    </g>
  </Svg>
));

BellIcon.displayName = 'BellIcon';

export default BellIcon;
